import { Controller } from 'stimulus'

export default class extends Controller {
  static values = { url: String }

  disconnect () {
    if (this._pending) {
      this._pending.abort()
    }
  }

  perform (event) {
    event.preventDefault()

    const controller = new AbortController()
    this._pending = controller

    const csrfToken = document.querySelector('meta[name=csrf-token]')?.content

    fetch(this.urlValue, {
      method: 'DELETE',
      signal: controller.signal,
      headers: {
        'X-CSRF-Token': csrfToken
      }
    }).then(() => {
      window.location.replace('/')
    })
  }
}
